var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "custom-box",
        {
          attrs: { title: _vm.$t("details"), visible: _vm.dialogShow },
          on: {
            "update:visible": function($event) {
              _vm.dialogShow = $event
            },
            close: function($event) {
              return _vm.clearData("ruleForm")
            }
          }
        },
        [
          _c(
            "div",
            { staticClass: "popover" },
            [
              _c(
                "el-form",
                {
                  ref: "ruleForm",
                  staticClass: "popover",
                  attrs: {
                    "label-position": "left",
                    rules: _vm.rules,
                    model: _vm.paramsData,
                    "label-width": "110px"
                  }
                },
                [
                  _c(
                    "el-form-item",
                    {
                      key: "template_id",
                      staticClass: "lodingItem",
                      attrs: {
                        prop: "template_id",
                        label: _vm.$t("templateName")
                      }
                    },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            clearable: "",
                            filterable: "",
                            placeholder: _vm.$t("pleaseInput")
                          },
                          model: {
                            value: _vm.paramsData.template_id,
                            callback: function($$v) {
                              _vm.$set(_vm.paramsData, "template_id", $$v)
                            },
                            expression: "paramsData.template_id"
                          }
                        },
                        _vm._l(_vm.templateNameList, function(item) {
                          return _c("el-option", {
                            key: item.id,
                            attrs: { label: item.template_name, value: item.id }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", round: "" },
                  on: { click: _vm.dataFormSubmit }
                },
                [_vm._v(" " + _vm._s(_vm.$t("confirm")) + " ")]
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }